import { useId, type ReactNode } from 'react';
import styles from './Swatch.module.css';

interface SwatchProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function Swatch({ label, value, onChange, className }: SwatchProps) {
  const id = useId();
  return (
    <div className={[styles.swatch, className ?? ''].filter(Boolean).join(' ')}>
      <input
        id={id}
        className={styles.input}
        type="color"
        value={value}
        onChange={e => onChange(e.target.value)}
      />
      <label className={styles.caption} htmlFor={id}>
        {label}
      </label>
    </div>
  );
}

export function SwatchRow({ children }: { children: ReactNode }) {
  return <div className={styles.swatches}>{children}</div>;
}
